import './features.css'

function Feature({room}) {
     return(
      <div className="img">
      {room?.roomsImg?.map((r) => (
          <img src={r} alt='' className='featured--img'/>
      ))}
      </div>
     )
}

export default Feature;
